import React, { MouseEvent } from "react"
import { useState } from "react"
import { createRoot } from "react-dom/client"
import { Modal } from "./comps/Modal"
import { HireMeModal } from "./hire-me-modal"

function HireMeButton(){
    const [show, setShow] = useState(false)
    return <>
        <a href="#" onClick={(e)=>{e.preventDefault(); setShow(true)}}>Hire Me</a>
        {show && <Modal onHide={() => setShow(false)} title="HIRE ME">
            <HireMeModal />
        </Modal>}
    </>
}

function createApp(){
    const element = document.querySelector('#hire-me-trigger') as any 
    
    const root = createRoot(element);
    root.render(<HireMeButton />)
    
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', createApp)
} else {
    createApp()
}